<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        <a
          href="#"
          @click.prevent="$router.push({ name: 'disciplinary-letter' })"
          class="mr-2"
        >
          <i class="fas fa-arrow-left"></i>
        </a>
        {{ $t('disciplinaryLetter.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('disciplinaryLetter.pageTitle'),
            href: '/disciplinary-letters'
          },
          {
            text: $t('add_new'),
            active: true
          }
        ]"
      />
    </div>
    <form class="form-horizontal">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <ts-card>
            <ts-card-wrapper>
              <div class="row form-group m-b-15">
                <label class="col-md-2 form-col-label control-label">
                  {{ $t('disciplinaryLetter.dateRange') }}
                </label>
                <div class="col-sm-4">
                  <a-range-picker
                    format="DD-MM-YYYY"
                    :defaultValue="rangeDate"
                    :defaultPickerValue="rangeDate"
                    @change="dateRangeChange"
                  >
                    <template slot="renderExtraFooter"></template>
                  </a-range-picker>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-2 form-col-label control-label">
                  {{ $t('disciplinaryLetter.comment') }}
                </label>
                <div class="col-sm-4">
                  <textarea
                    rows="4"
                    class="form-control"
                    v-model="model.comments"
                  ></textarea>
                  <div class="invalid-feedback" v-if="errors.has('comments')">
                    {{ errors.first('comments') }}
                  </div>
                </div>
              </div>
            </ts-card-wrapper>
            <div class="overflow-auto">
              <ts-table
                :columns="columns"
                :records="resources"
                :loading="loading"
              >
                <template v-slot="{ record }">
                  <td class="ts-whitespace-no-wrap">
                    {{ record.student_name }}
                  </td>
                  <td class="ts-whitespace-no-wrap">
                    {{ record.dis_type }}
                  </td>
                  <td class="ts-whitespace-no-wrap">
                    {{ record.dis_sub_type }}
                  </td>
                  <td class="ts-whitespace-no-wrap">
                    {{ record.dis_activity }}
                  </td>
                  <td class="text-center ts-whitespace-no-wrap">
                    <a
                      href="#"
                      class="btn btn-info btn-xs"
                      @click.prevent="issue(record)"
                      :disabled="record._deleting"
                    >
                      <i
                        class="fas fa-circle-notch spin"
                        v-if="record._deleting"
                      ></i>
                      <span v-else>Issue</span>
                    </a>
                  </td>
                </template>
              </ts-table>
            </div>
            <div class="d-flex justify-content-end p-15">
              <ts-pagination v-model="pagination" @navigate="fetchData">
              </ts-pagination>
            </div>
          </ts-card>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'disciplinary-letter-create',
  data () {
    return {
      model: {
        comments: ''
      },
      rangeDate: [moment().add(-1, 'Month'), moment()],
      errors: new Errors(),
      loading: false
    }
  },
  computed: {
    ...mapState('disciplinaryLetter', ['resources', 'pagination']),
    columns () {
      return [
        {
          name: this.$t('disciplinaryLetter.studentName')
        },
        {
          name: this.$t('disciplinaryLetter.disciplinaryType')
        },
        {
          name: this.$t('disciplinaryLetter.disciplinarySubType')
        },
        {
          name: this.$t('disciplinaryLetter.disciplinaryActivity')
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:1%'
        }
      ]
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('disciplinaryLetter/fetchDisciplinary', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    dateRangeChange (dateRange) {
      this.$store.commit(
        'disciplinaryLetter/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'disciplinaryLetter/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    },
    issue (record) {
      record._deleting = true
      this.$store
        .dispatch(
          'disciplinaryLetter/store',
          Object.assign({}, this.model, record)
        )
        .then(response => {
          this.fetchData()
          this.$toasted.success(response.message)
          record._deleting = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          record._deleting = false
        })
    }
  },
  watch: {},
  beforeRouteLeave (to, from, next) {
    this.$store.commit('disciplinaryLetter/RESET_STATE')
    next()
  }
}
</script>
